
import { defineComponent } from 'vue'
import ActionButton from '@/components/ActionButton.vue'
import KanbanAddForm from '@/components/KanbanAddForm.vue'
import Avatar from '@/components/Avatar.vue'
import KanbanTaskLabel from '@/components/KanbanTaskLabel.vue'
import KanbanTaskAttachment from '@/components/KanbanTaskAttachment.vue'
import KanbanTaskCommentInput from '@/components/KanbanTaskCommentInput.vue'
import KanbanTaskComment from '@/components/KanbanTaskComment.vue'
import WorkspaceDropdown from '@/components/WorkspaceDropdown.vue'
import MembersDropDownContent from '@/components/MembersDropDownContent.vue'
import LabelDropDownContent from '@/components/LabelDropDownContent.vue'
import AttachmentDropDownContent from '@/components/AttachmentDropDownContent.vue'
import TaskCardActionForm from '@/components/TaskCardActionForm.vue'
import CopyCardDropDownContent from '@/components/CopyCardDropDownContent.vue'
import DatesDropDownContent from '@/components/DatesDropDownContent.vue'
import { mapState } from 'vuex'
import { createTaskCommentService, editTaskService, moveTaskService } from '@/services/task'
import { LabelType, MemberType } from '@/types/entities'

export default defineComponent({
  components: {
    ActionButton,
    KanbanAddForm,
    Avatar,
    KanbanTaskLabel,
    KanbanTaskAttachment,
    KanbanTaskCommentInput,
    KanbanTaskComment,
    WorkspaceDropdown,
    MembersDropDownContent,
    LabelDropDownContent,
    AttachmentDropDownContent,
    TaskCardActionForm,
    CopyCardDropDownContent,
    DatesDropDownContent
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  inject: ['getBoardById', 'updateListTask', 'indexTasksByList', 'list', 'task', 'taskMembers', 'taskLabels', 'cover'],
  data () {
    return {
      showAddMemberDD: false,
      showAddLabelDD: false,
      showMembersDD: false,
      showLabelsDD: false,
      showDateDD: false,
      showAttachmentDD: false,
      showMoveDD: false,
      showCopyDD: false,
      showDescriptionBox: false
    }
  },
  methods: {
    async handleDescriptionChange (v: string) {
      const res = await editTaskService(this.$route.params.boardId, this.list._id, this.task._id, {
        description: v
      })
      if (!res.error) {
        this.showDescriptionBox = false
        this.updateListTask(res.data)
      }
    },
    async handleTaskNameChange (event: Event) {
      const target = event.target as HTMLInputElement
      const res = await editTaskService(this.$route.params.boardId, this.list._id, this.task._id, {
        task: target.value
      })
      if (!res.error) {
        this.$refs.taskNameInput.blur()
        this.updateListTask(res.data)
      }
    },
    async handleAddMemberToTask (member: MemberType) {
      const res = await editTaskService(this.$route.params.boardId, this.list._id, this.task._id, {
        members: [...this.task.members, member._id]
      })
      if (!res.error) {
        this.updateListTask(res.data)
      }
    },
    async handleRemoveMemberFromTask (member: MemberType) {
      const res = await editTaskService(this.$route.params.boardId, this.list._id, this.task._id, {
        members: this.task.members.filter((mem: string) => mem !== member._id)
      })
      if (!res.error) {
        this.updateListTask(res.data)
      }
    },
    async handleAddLabelToTask (label: LabelType) {
      const res = await editTaskService(this.$route.params.boardId, this.list._id, this.task._id, {
        labels: [...this.task.labels, label._id]
      })
      if (!res.error) {
        this.updateListTask(res.data)
      }
    },
    async handleRemoveLabelFromTask (label: LabelType) {
      const res = await editTaskService(this.$route.params.boardId, this.list._id, this.task._id, {
        labels: this.task.labels.filter((lab: string) => lab !== label._id)
      })
      if (!res.error) {
        this.updateListTask(res.data)
      }
    },
    async handleTaskComment (comment: string) {
      const res = await createTaskCommentService(this.$route.params.boardId, this.list._id, this.task._id, { comment })
      if (!res.error) {
        this.updateListTask(res.data)
      }
    },
    async handleDateChange (payload: Record<string, string>) {
      const res = await editTaskService(this.$route.params.boardId, this.list._id, this.task._id, payload)
      if (!res.error) {
        this.showDateDD = false
        this.updateListTask(res.data)
      }
    },
    async handleMoveTask (payload: Record<string, string>) {
      console.log(this.list._id, payload)
      const res = await moveTaskService(
        this.$route.params.boardId,
        payload.toBoardId,
        this.list._id,
        payload.toListId,
        this.task._id
      )
      if (!res.error) {
        this.$emit('close')
        this.showMoveDD = false
        this.$nextTick(() => {
          this.$store.commit('MOVE_CURRENTBOARD_LIST_TASK', {
            fromListId: this.list._id,
            toListId: payload.toListId,
            taskId: this.task._id
          })
        })
      }
    }
  },
  watch: {
    taskMembers (v) {
      if (!v.length) this.showAddMemberDD = false
    },
    taskLabels (v) {
      if (!v.length) this.showAddLabelDD = false
    }
  },
  computed: {
    ...mapState({
      currentBoard: 'currentBoard'
    })
  }
})
